export default "__VITE_ASSET__CrUxS1H$__"